var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLTabs",
    { staticClass: "guideline-tabs-outer", attrs: { defaultActiveKey: 1 } },
    [
      _c(
        "a-tab-pane",
        { key: 1, attrs: { tab: _vm.$t("settings.regionConfig.env") } },
        [_c("EnvPage")],
        1
      ),
      _vm._v(" "),
      _c(
        "a-tab-pane",
        { key: 2, attrs: { tab: _vm.$t("settings.regionConfig.terms") } },
        [_c("TncIndex")],
        1
      ),
      _vm._v(" "),
      _c(
        "a-tab-pane",
        { key: 3, attrs: { tab: _vm.$t("settings.regionConfig.images") } },
        [_c("RegionImage")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }